import React from "react";
import '../App.css';
import './Obrazovanje.css';
import Header from '../components/Header';
import Footer from '../components/Footer'
import img1 from '../images/modal/111.jpg';
import img2 from '../images/modal/112.jpg';
import img3 from '../images/modal/113.jpg';
import img4 from '../images/modal/114.jpg';
import img5 from '../images/modal/115.jpg';

const Osposobljavanje = () => {

    return(
        <div>
            <Header />
                <div className="prekvalifikacija">
                    <div>
                        <div className="btt">
                            <h1>Osposobljavanje</h1>
                            <h4>Nastavni programi za stručno osposobljavanje su urađeni da osposobe polaznike <br />
                                za samostalan rad na manje složenim poslovima na gradilištima, u skladištima i drugim odgovarajućim mjestima. <br />
                                Osposobljavanje je namijenjeno polaznicima sa završenom osnovnom <br />
                                ili srednjom školom i navršenih 18 godina života. Po završenom obrazovanju polaznici <br />
                                dobivaju Uvjerenje o osposobljenosti za vrstu programa koji su pohađali.<br />
                                Sticanjem obrazovanja o stručnoj osposobljenosti ne dobija se srednja stručna sprema.<br />
                                <br />
                                Potrebna dokumentacija za upis:<br />
                                - Diploma o završenoj srednjoj školi ili svjedočanstvo o završenom IX razredu <br />
                                - Kopija lične karte <br />
                                - Rodni list <br />
                                <br />
                                Cilj programa je osposobiti polaznika koji će moći obavljati manje složene poslove za slijedeća zanimanja:</h4>
                        </div>
                        <div className="tabela">
                                <h4>
                                    -Program osposobljavanja za zavarivača mig-mag postupkom <br />
                                    -Program osposobljavanja za zavarivača tig postupkom <br />
                                    -Program osposobljavanja za obavljanje poslova njegovatelja starijih i nemoćnih lica <br />
                                    -Program osposobljavanja za plasteničku proizvodnju <br />
                                    -Program osposobljavanja za poslove armirača <br />
                                    -Program osposobljavanja za poslove vodoinstalatera <br />
                                    -Program osposobljavanja za poslove dimnjačara <br />
                                    -Program osposobljavanja za poslove zidara <br />
                                    -Program osposobljavanja za poslove molera <br />
                                    -Program osposobljavanja za poslove pekara <br />
                                    -Program osposobljavanja za poslove pčelara <br />
                                    -Program osposobljavanja za poslove rukovaoca građevinskih mašina <br />
                                    -Program osposobljavanja za poslove tesara <br />
                                    -Program osposobljavanja za poslove trenera jahanja <br />
                                    -Program osposobljavanja sakupljača samoniklog ljekovitog bilja, šumskih plodova i gljiva
                                </h4>
                        </div>
                    </div>

                    <div className="nvijesti">
                        <div className="vijestiimg">
                            <img className="vimg" src={img1} alt="vijest1" />
                        </div>

                        <div className="vijestiimg">
                            <img className="vimg" src={img5} alt="vijest4"/>
                        </div>

                        <div className="vijestiimg">
                        <img className="vimg" src={img2}  alt="vijest2"/>
                        </div>

                        <div className="vijestiimg">
                        <img className="vimg" src={img3} alt="vijest3" />
                        </div>

                        <div className="vijestiimg">
                            <img className="vimg" src={img4} alt="vijest4"/>
                        </div>
                    </div>


                </div>
            <Footer />
        </div>
    );

}

export default Osposobljavanje;